import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { FilterTagsComponent } from '../filter-tags/filter-tags.component';
import { SearchFieldDto, ThesaurusSearchType } from 'src/app/models/search-field-dto';

@Component({
  selector: 'app-thesaurus-filter-tags',
  templateUrl: './thesaurus-filter-tags.component.html',
  styleUrls: ['./thesaurus-filter-tags.component.scss']
})
export class ThesaurusFilterTagsComponent extends FilterTagsComponent {
  @Output() searchTypeChange = new EventEmitter<{tag: SearchFieldDto, searchType: ThesaurusSearchType}>();
  
  @ViewChild('searchTypeSelector') searchTypeSelector!: any;
  
  currentTag: SearchFieldDto | null = null;
  private currentOpenerElement: HTMLElement | null = null;


  getSearchTypeIcon(tag: SearchFieldDto): string {
    const searchType = tag.searchType || 'branch';
    const icons = {
      'branch': 'assets/branch.svg',
      'term': 'assets/mid.svg',
      'word': 'assets/wid.svg'
    };
    return icons[searchType];
  }

  openSearchTypePopup(event: Event, tag: SearchFieldDto) {
    event.preventDefault();
    event.stopPropagation();
    this.currentTag = tag;
    const target = event.target as HTMLElement;
    this.currentOpenerElement = target;
    // Explicitly set the value before toggling
    this.searchTypeSelector.value = tag.searchType || 'branch';
    this.searchTypeSelector.toggle(event);
  }

  handleSearchTypeIconKeydown(event: KeyboardEvent, tag: SearchFieldDto) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      this.openSearchTypePopup(event, tag);
    }
  }

  onSearchTypeChange(searchType: ThesaurusSearchType) {
    if (this.currentTag) {
      this.searchTypeChange.emit({ tag: this.currentTag, searchType });
      // Special aggressive focus restoration for preview panel inside modal dialog
      const openerElement = this.currentOpenerElement;
      const iconId = openerElement?.id;
      
      if (iconId) {
        // Use ID-based lookup which works better inside modal dialogs
        const attemptFocus = (delay: number) => {
          setTimeout(() => {
            const element = document.getElementById(iconId);
            if (element) {
              element.focus();
            }
          }, delay);
        };
        
        // Multiple attempts with increasing delays to overcome modal focus trap
        attemptFocus(0);
        attemptFocus(150);
        attemptFocus(350);
        attemptFocus(600);
      }
    }
  }

  getCurrentTagId(): string {
    // Include categoryId for advanced thesaurus to ensure uniqueness
    if (this.currentTag?.categoryId !== undefined) {
      return `tag-${this.currentTag.categoryId}-${this.currentTag.id}`;
    }
    return 'tag-' + (this.currentTag?.id || 'default');
  }

    getDisplayLabel(tag: SearchFieldDto): any {
    // If tag has a prefix, prepend it
    if (tag.prefix && tag.label) {
      if (typeof tag.label === 'string') {
        return `${tag.prefix}: ${tag.label}`;
      } else if (tag.label.hebrew && tag.label.english) {
        return {
          hebrew: `${tag.prefix.hebrew}: ${tag.label.hebrew}`,
          english: `${tag.prefix.english}: ${tag.label.english}`
        };
      }
    }
    return tag.label;
  }
}
